import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Link2, Copy, Download } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

export default function ShareBookingLink({ doctorId }) {
  const qrRef = useRef(null);
  const url = `${window.location.origin}/agendar/${doctorId}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiado");
    } catch {
      toast.error("No se pudo copiar. Selecciona el link y cópialo manualmente.");
    }
  };

  const download = () => {
    const canvas = qrRef.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "qr-agendar-cita.png";
    a.click();
  };

  return (
    <div className="flex flex-col gap-5 rounded-2xl border border-[#E2E8F0] bg-white p-6 sm:flex-row sm:items-center" data-testid="share-booking-link">
      <div ref={qrRef} className="shrink-0 rounded-xl border border-[#E2E8F0] bg-white p-2" data-testid="booking-qr">
        <QRCodeCanvas value={url} size={132} marginSize={1} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
          <Link2 className="h-4 w-4 text-[#0284C7]" /> Link para que tus pacientes agenden
        </div>
        <p className="mt-1 text-xs font-semibold text-slate-400">Compártelo o imprime el QR: el paciente verá tus horarios y podrá agendar directamente.</p>
        <div className="mt-3 truncate rounded-xl border border-[#E2E8F0] bg-slate-50 px-3 py-2 text-sm font-bold text-slate-700" data-testid="booking-link-url">{url}</div>
        <div className="mt-3 flex flex-wrap gap-2">
          <Button type="button" onClick={copy} className="rounded-full bg-[#0284C7] font-bold hover:bg-[#0369a1]" data-testid="copy-booking-link-btn">
            <Copy className="mr-1.5 h-4 w-4" /> Copiar link
          </Button>
          <Button type="button" variant="outline" onClick={download} className="rounded-full border-[#E2E8F0] font-bold" data-testid="download-qr-btn">
            <Download className="mr-1.5 h-4 w-4" /> Descargar QR
          </Button>
        </div>
      </div>
    </div>
  );
}
